/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AutosavePalAuthSubmissionConflictReason = {
    NotEditable: 'not_editable',
    StaleForm: 'stale_form',
    StaleRevision: 'stale_revision',
} as const;
export type AutosavePalAuthSubmissionConflictReason = typeof AutosavePalAuthSubmissionConflictReason[keyof typeof AutosavePalAuthSubmissionConflictReason];


export function instanceOfAutosavePalAuthSubmissionConflictReason(value: any): boolean {
    for (const key in AutosavePalAuthSubmissionConflictReason) {
        if (Object.prototype.hasOwnProperty.call(AutosavePalAuthSubmissionConflictReason, key)) {
            if (AutosavePalAuthSubmissionConflictReason[key as keyof typeof AutosavePalAuthSubmissionConflictReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AutosavePalAuthSubmissionConflictReasonFromJSON(json: any): AutosavePalAuthSubmissionConflictReason {
    return AutosavePalAuthSubmissionConflictReasonFromJSONTyped(json, false);
}

export function AutosavePalAuthSubmissionConflictReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutosavePalAuthSubmissionConflictReason {
    return json as AutosavePalAuthSubmissionConflictReason;
}

export function AutosavePalAuthSubmissionConflictReasonToJSON(value?: AutosavePalAuthSubmissionConflictReason | null): any {
    return value as any;
}

export function AutosavePalAuthSubmissionConflictReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): AutosavePalAuthSubmissionConflictReason {
    return value as AutosavePalAuthSubmissionConflictReason;
}

